import ApiCallerInterface from 'fk-cp-common-components/actions/ApiCallerInterface';
import ApiStoreInterface from './ApiStoreInterface';
import MapiBaseAjaxConfig from '../MapiBaseAjaxConfig';
import { keyBy } from 'fk-cp-common-components/utils/objectUtils';

const ApiInterfaceCaller = (httpMethod = 'get', query, action, args, extraHeaders) => {
	const headers = { ...MapiBaseAjaxConfig.getConfig().headers, ...extraHeaders };
	const payload = {
		apiCaller: ApiStoreInterface,
		config: { ...MapiBaseAjaxConfig.getConfig(), headers },
		httpMethod,
		query
	};

	return ApiCallerInterface(payload, action, args);
};

export const ApiCallerV4InlineAction = ({ method, queryParam, headers, url, payload }) => {
	const config = MapiBaseAjaxConfig.getConfig();
	const headersObject = keyBy(headers);
	return ApiStoreInterface[method.toLowerCase()](
		{
			...config,
			headers: {
				...config.headers,
				...headersObject
			},
			pathname: `api/${url}`,
			query: queryParam
		},
		payload
	).then(({ RESPONSE }) => RESPONSE);
};

export default ApiInterfaceCaller;
